import request from '@/utils/request'

function getSdkConfig(data) {
  return request({
    url: '/user/getWxConfig',
    method: 'post',
    data
  })
}

export default {
  getSdkConfig,
}
